import { TouchableOpacity, View } from "react-native";
import { ActivityIndicator, Text } from "react-native-paper";
import NotFound from "../../components/NotFound";
import pluralize from "../../utils/pluralize";
import { useNavigation } from "@react-navigation/native";
import { sumBy, sortBy } from "lodash";
import PdrItem from "./components/PdrItem";
import { PdrHistory } from "../../screens/fragments";
import { useQuery } from "@apollo/client";
import { PDR_HISTORY_QUERY } from "./queries";
import useAmplitude from "../../hooks/useAmplitude";
import { SlugList } from "../ReportPDRs/types";

export type PdrHistoryQuery = {
  currentPerson: {
    pdrHistory: PdrHistory[];
  };
};

function getSlugName(code: string): string {
  const key = Object.keys(SlugList).find((key) => SlugList[key as keyof typeof SlugList] === code);
  return key || "";
}

const PdrHistoryData = () => {
  const { data, loading } = useQuery<PdrHistoryQuery>(PDR_HISTORY_QUERY);
  const navigation = useNavigation();
  const { trackEvent } = useAmplitude();
  if (loading) {
    return <ActivityIndicator className="py-32 items-center justify-center mt-6" />;
  }

  const onViewPdrDetail = (id: string, slug: string) => {
    trackEvent("click-view-pdr-detail", {
      pdr_activity_category_name: slug,
    });
    navigation.navigate("PdrDetails", { id });
  };

  const pdrHistory = sortBy(data?.currentPerson?.pdrHistory, "submittedAt").reverse();
  const creditsAccepted = sumBy(pdrHistory, "creditsAccepted");

  if (!pdrHistory || pdrHistory.length === 0) {
    return (
      <NotFound
        title="PDR History"
        message="No PDRs found in the current cycle. Select another cycle from the dropdown to view additional results."
        insideModal
      />
    );
  }

  return (
    <View className="mb-8">
      <View className="flex-row justify-between items-center px-6 py-3 bg-sky-lightest border-b border-sky border-t md:border-l md:border-r md:rounded md:px-4">
        <Text className="text-small-tight font-700 text-ink-darkest">Reviewed</Text>
        <Text className="text-small-tight font-700 text-ink-darkest">
          {pluralize(creditsAccepted, "Credit")} {creditsAccepted}
        </Text>
      </View>
      {pdrHistory.map((a, key) => (
        <TouchableOpacity onPress={() => onViewPdrDetail(a.id, getSlugName(a.activityCode))} key={key}>
          <PdrItem pdr={a} isLast={key === pdrHistory.length - 1} />
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default PdrHistoryData;
